import { Box } from "@material-ui/core";
import { WifiOff as WifiOffIcon } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";

import { Typography } from "components/common";

const NetworkErrorToast = () => (
  <Box display="flex" alignItems="center" gridGap="10px">
    <WifiOffIcon fontSize="medium" />
    <Typography variant="body2SmallSemibold">
      <FormattedMessage id="errors.networkError" /> <br />
      <Typography variant="body2SmallLight" component="span">
        <FormattedMessage id="errors.checkNetwork" />
      </Typography>
    </Typography>
  </Box>
);

export default NetworkErrorToast;
